import { render, staticRenderFns } from "./DialogChats.vue?vue&type=template&id=17fcbf5e"
import script from "./DialogChats.vue?vue&type=script&lang=js"
export * from "./DialogChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports